var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-tag',{attrs:{"color":_vm.getStatusColor(_vm.status)}},[_vm._v(_vm._s(_vm.status || "N/A"))])}
var staticRenderFns = []

export { render, staticRenderFns }